import IframeActivity from "./IframeActivity";

export default function SoManyOpportunities() {
    return (
        <IframeActivity
            src="/activities/so-many-opportunities/index.html"
            title="So Many Opportunities"
        />
    );
}